import { render, staticRenderFns } from "./ci-requests-table.vue?vue&type=template&id=d501394a&scoped=true&"
import script from "./ci-requests-table.vue?vue&type=script&lang=js&"
export * from "./ci-requests-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d501394a",
  null
  
)

export default component.exports